import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

// Delivery Management "Recon List" row icon: a banknote with a rupee
// sign, in the same 38×38 grey tile as the other rows' icons.
function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F3F3F3" />
      <Path
        d="M8.5 12.75A1.75 1.75 0 0110.25 11h17.5a1.75 1.75 0 011.75 1.75v12.5A1.75 1.75 0 0127.75 27h-17.5a1.75 1.75 0 01-1.75-1.75v-12.5zm1.5 0v12.5c0 .14.11.25.25.25h17.5c.14 0 .25-.11.25-.25v-12.5a.25.25 0 00-.25-.25h-17.5a.25.25 0 00-.25.25z"
        fill="#000"
        fillOpacity={0.6}
      />
      <Path
        d="M12.25 14.5h2a.75.75 0 010 1.5h-2a.75.75 0 010-1.5zm11.5 7.5h2a.75.75 0 010 1.5h-2a.75.75 0 010-1.5z"
        fill="#000"
        fillOpacity={0.6}
      />
      <Path
        d="M16.4 14.75h5.2a.7.7 0 110 1.4h-1.26c.3.36.5.8.57 1.3h.69a.7.7 0 110 1.4h-.69a2.9 2.9 0 01-2.81 2.3h-.3l2.7 2.63a.7.7 0 01-.98 1l-3.9-3.8a.7.7 0 01.49-1.2h1.99c.67 0 1.24-.4 1.46-.93H16.4a.7.7 0 110-1.4h3.16a1.52 1.52 0 00-1.46-.9H16.4a.7.7 0 110-1.4z"
        fill="#000"
        fillOpacity={0.6}
      />
    </Svg>
  );
}

export default SvgComponent;
